import {
  SubscribeTypes,
  SUBSCRIBE_ERROR,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBING,
  REPLACE_PAYMENT_METHOD_ERROR,
  REPLACE_PAYMENT_METHOD_SUCCESS,
  REPLACING_PAYMENT_METHOD,
  REGISTER_SUBSCRIBER_ERROR,
  REGISTER_SUBSCRIBER_SUCCESS,
  REGISTERING_SUBSCRIBER,
  FORCE_SUBSCRIPTION_PAYMENT_ERROR,
  FORCE_SUBSCRIPTION_PAYMENT_SUCCESS,
  FORCING_SUBSCRIPTION_PAYMENT,
} from '../config/ActionTypes';
import { SubscriberState } from '../config/types/subscriber.types';

export const subscriberInitialState: SubscriberState = {
  subscribing: false,
  subscribeSuccess: false,
  subscribeErrorMessage: null,
  replacingPaymentMethod: false,
  replacePaymentMethodSuccess: false,
  replacePaymentMethodPlexoUrl: null,
  replacePaymentMethodError: null,
  registeringSubscriber: false,
  registerSubscriberSuccess: false,
  plexoUrl: null,
  registerSubscriberErrorMessage: null,
  forcingSubscriptionPayment: false,
  forceSubscriptionPaymentSuccess: false,
  forceSubscriptionPaymentError: null,
};

export function subscriberReducer(state = subscriberInitialState, action: SubscribeTypes): SubscriberState {
  switch (action.type) {
    case SUBSCRIBING:
      return {
        ...state,
        subscribing: true,
        subscribeSuccess: false,
        subscribeErrorMessage: null,
      };

    case SUBSCRIBE_SUCCESS:
      return {
        ...state,
        subscribing: false,
        subscribeSuccess: true,
        subscribeErrorMessage: null,
      };

    case SUBSCRIBE_ERROR:
      return {
        ...state,
        subscribing: false,
        subscribeSuccess: false,
        subscribeErrorMessage: action.error,
      };

    case REPLACING_PAYMENT_METHOD:
      return {
        ...state,
        replacingPaymentMethod: true,
        replacePaymentMethodSuccess: false,
        replacePaymentMethodPlexoUrl: null,
        replacePaymentMethodError: null,
      };

    case REPLACE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        replacingPaymentMethod: false,
        replacePaymentMethodSuccess: true,
        replacePaymentMethodPlexoUrl: action.replacePaymentMethodPlexoUrl,
        replacePaymentMethodError: null,
      };

    case REPLACE_PAYMENT_METHOD_ERROR:
      return {
        ...state,
        replacingPaymentMethod: false,
        replacePaymentMethodSuccess: false,
        replacePaymentMethodError: action.error,
      };

    case REGISTERING_SUBSCRIBER:
      return {
        ...state,
        registeringSubscriber: true,
        registerSubscriberSuccess: false,
        plexoUrl: null,
        registerSubscriberErrorMessage: null,
      };

    case REGISTER_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        registeringSubscriber: false,
        registerSubscriberSuccess: true,
        plexoUrl: action.plexoUrl,
        registerSubscriberErrorMessage: null,
      };

    case REGISTER_SUBSCRIBER_ERROR:
      return {
        ...state,
        registeringSubscriber: false,
        registerSubscriberSuccess: false,
        registerSubscriberErrorMessage: action.error,
      };

    case FORCING_SUBSCRIPTION_PAYMENT:
      return {
        ...state,
        forcingSubscriptionPayment: true,
        forceSubscriptionPaymentSuccess: false,
        forceSubscriptionPaymentError: null,
      };

    case FORCE_SUBSCRIPTION_PAYMENT_SUCCESS:
      return {
        ...state,
        forcingSubscriptionPayment: false,
        forceSubscriptionPaymentSuccess: true,
        forceSubscriptionPaymentError: null,
      };

    case FORCE_SUBSCRIPTION_PAYMENT_ERROR:
      return {
        ...state,
        forcingSubscriptionPayment: false,
        forceSubscriptionPaymentSuccess: false,
        forceSubscriptionPaymentError: action.error,
      };

    default:
      return state;
  }
}
